import React from "react";

import LocationSelector from "components/LocationSelector/LocationSelector";
import DayWeekSelector from "./DayWeekSelector";
import ViewSelector from "./ViewSelector";

import { Space } from "antd";
import OperationTypeSelector from "components/OperationTypeSelector/OperationTypeSelector";
import { CalenderOperationType, VIEWS } from "utils/enums";
import CalendarFilters from "components/Calendar/components/CalendarFilters";

const Toolbar = (params) => {
  const {
    date,
    view,
    onView,
    onNavigate,
    operationType,
    setOperationType,
    showFilter,
    setShowFilter,
  } = params;

  const renderControls = () => {
    return (
      <>
        <DayWeekSelector date={date} onNavigate={onNavigate} />
        <Space size={16} className="toolbarSizer">

          <CalendarFilters
            setShowFilter={setShowFilter}
            showFilter={showFilter}
          />
          <ViewSelector
            view={view}
            onView={onView}
            views={
              operationType === CalenderOperationType.Telehealth
                ? [VIEWS.AGENDA]
                : [VIEWS.DAY, VIEWS.AGENDA, VIEWS.DISPATCH_LOG]
            }
          />
        </Space>
      </>
    );
  };

  return (
    <div className="toolbar">
      {/* <OperationTypeSelector
        value={operationType}
        onChange={setOperationType}
      />

      {(operationType === CalenderOperationType.All ||
        operationType === CalenderOperationType.Telehealth) && ( */}
      <LocationSelector />
      {/* )} */}
      {renderControls()}
    </div>
  );
};

export default Toolbar;
